import { render, staticRenderFns } from "./videoProject.vue?vue&type=template&id=c5e0f494&"
import script from "./videoProject.vue?vue&type=script&lang=js&"
export * from "./videoProject.vue?vue&type=script&lang=js&"
import style0 from "./videoProject.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "videoProject.vue"
export default component.exports